import { useEffect, useState } from "react";
import { ArrowLeft } from "phosphor-react";
import {
  Link,
  useActionData,
  useLocation,
  useTransition,
} from "@remix-run/react";

import { fireToast } from "~/global/utils";
import { Button, TextInput } from "~/components/ui";

import { ForgotViewContainer, ForgotForm } from "./styles";
import { Toaster } from "react-hot-toast";

export function ForgotView() {
  const actionData = useActionData();
  const transition = useTransition();

  const { pathname } = useLocation();

  const [location, setLocation] = useState("");

  useEffect(() => {
    setLocation(window.location.hostname);
    if (actionData?.toast) fireToast(actionData?.toast);
  }, [actionData]);

  return (
    <ForgotViewContainer>
      <Toaster position="top-right" containerStyle={{ zIndex: 99999 }} />

      <h1>
        {location.includes("pca")
          ? "PAC - Plano anual de contratações"
          : "Gestor de Atas"}
      </h1>

      <ForgotForm method="post">
        {pathname !== "/auth/change-code" && (
          <Link to="/auth/signin" className="back_link">
            <ArrowLeft size={26} />
          </Link>
        )}
        <h2>
          {pathname === "/auth/change-code"
            ? "Coloque o código de acesso"
            : "Recupere sua senha"}
        </h2>
        <p>
          {pathname === "/auth/change-code"
            ? "Por favor, digite o código para que possamos validar a sua recuperação de senha."
            : "Por favor, digite o seu e-mail para que possamos enviar um link para recuperação de senha."}
        </p>

        <TextInput
          name={pathname === "/auth/change-code" ? "code" : "email"}
          placeholder={
            pathname === "/auth/change-code" ? "******" : "email@email.com"
          }
          label={pathname === "/auth/change-code" ? "Código" : "E-mail"}
          error={
            pathname === "/auth/change-code"
              ? actionData?.error?.code
              : actionData?.error?.email
          }
        />

        <Button
          isLoading={transition.state === "submitting"}
          name="_action"
          value={
            pathname === "/auth/change-code" ? "sendCode" : "sendForgotEmail"
          }
        >
          {pathname === "/auth/change-code" ? "Verificar" : "Enviar"}
        </Button>

        {pathname !== "/auth/change-code" && (
          <Link to="/auth/forgot">Não recebeu o link?</Link>
        )}
      </ForgotForm>
    </ForgotViewContainer>
  );
}
